import Screen from 'quasar/src/plugins/Screen.js';
import _ from 'lodash'

export default {
  props: {
    dense: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    computedDense () {
      return _.isNil(this.dense) && Screen.lt.lg ? true : this.dense
    }
  }
}
